export var BIF_PLUGIN_ID="@dicetechnology/doris-plugin-bif";